import { render, staticRenderFns } from "./menuDiaolog.vue?vue&type=template&id=523d6c2e&scoped=true"
import script from "./menuDiaolog.vue?vue&type=script&lang=js"
export * from "./menuDiaolog.vue?vue&type=script&lang=js"
import style0 from "./menuDiaolog.vue?vue&type=style&index=0&id=523d6c2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d6c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523d6c2e')) {
      api.createRecord('523d6c2e', component.options)
    } else {
      api.reload('523d6c2e', component.options)
    }
    module.hot.accept("./menuDiaolog.vue?vue&type=template&id=523d6c2e&scoped=true", function () {
      api.rerender('523d6c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/menus/menuDiaolog.vue"
export default component.exports